import {
  message
} from "antd";
import { BaseModel } from "../model";
import { useMediaQuery } from 'react-responsive';


export const exportPubFiles = (data: Blob, fileName: string) => {
  // 这里是全局方法的具体实现
  // Get ready
  const u = URL.createObjectURL(data);
  const _link = document.createElement('a');

  // Set attrs
  _link.download = fileName;
  _link.href = u;
  _link.style.display = 'none';
  document.body.append(_link);

  // Action download
  _link.click();

  // Clean
  URL.revokeObjectURL(u);
  document.body.removeChild(_link);
};

export function debounce(
  fn: (...args: any[]) => void, _this: unknown, delay: number = 0
): (...args: any[]) => void {
  let timer: NodeJS.Timeout;
  return function (...args: []) {
    timer && clearTimeout(timer);
    timer = setTimeout(() => {
      fn.call(_this, ...args)
    }, delay)
  }
}

export const getLoginUserInfo = (): BaseModel["LoginResp"] | null => {
  const loginUserinfo = localStorage.getItem("loginUserinfo");

  if (loginUserinfo) {
    try {
      return JSON.parse(loginUserinfo) as BaseModel["LoginResp"];
    } catch (error) {
      console.error("Error parsing loginUserinfo:", error);
      return null;
    }
  }
  return null;
};

export const permissshow = (premissscode: string): boolean => {
  const loginUserinfo = localStorage.getItem("loginUserinfo");
  if (!loginUserinfo) {
    return false;
  }
  const userinfoobj: BaseModel["LoginResp"] = JSON.parse(loginUserinfo) as BaseModel["LoginResp"];
  if (userinfoobj.premissionCodes.length === 0) {
    return false;
  }
  return userinfoobj.premissionCodes.includes(premissscode);
};

export const ismain = (): boolean => {
  const loginUserinfo = localStorage.getItem("loginUserinfo");
  if (!loginUserinfo) {
    return false;
  }
  const userinfoobj: BaseModel["LoginResp"] = JSON.parse(loginUserinfo) as BaseModel["LoginResp"];

  return userinfoobj.ismain;
};

export const getToken = (): string => {
  const loginUserinfo = localStorage.getItem("loginUserinfo");
  if (!loginUserinfo) {
    return "";
  }
  const userinfoobj: BaseModel["LoginResp"] = JSON.parse(loginUserinfo) as BaseModel["LoginResp"];

  return userinfoobj.token;
};

export const copyText = (textToCopy: string) => {
  // 使用 Clipboard API 进行复制
  navigator.clipboard.writeText(textToCopy)
    .then(() => {
      // 如果复制成功，显示成功消息
      message.success(`${textToCopy} 复制成功`);
    })
    .catch(err => {
      message.error(`${err} 复制失败`);
    });
}

export const textOption = <T extends { value: number; label: string }>(opt: T[], key: number): string | undefined => {
  const found = opt.find(item => item.value === key);
  return found ? found.label : undefined; // 找到对应项则返回 label，否则返回 undefined
};

export const generateRandomPassword = (length: number) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*_-+=<>?';
  let password = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    password += characters[randomIndex];
  }
  return password;
};

export const IsSmallScreen = () => {
  return useMediaQuery({ query: '(max-width: 767px)' });
}